import { render, staticRenderFns } from "./VideoFloat.vue?vue&type=template&id=e28a39f0&scoped=true&"
import script from "./VideoFloat.vue?vue&type=script&lang=js&"
export * from "./VideoFloat.vue?vue&type=script&lang=js&"
import style0 from "./VideoFloat.vue?vue&type=style&index=0&id=e28a39f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a39f0",
  null
  
)

export default component.exports